<template lang="pug">
    .status(:style='{background: color }')
        .status-content
            i.material-icons {{icon}}
            span {{title}}
            v-divider
            h6 {{total}}

</template>

<script>
export default {
    props:["title","icon","color","total"]
}
</script>


<style>
    .status{
        width:100%;
        height:120px;
        padding:15px;
        color:#fff;
        margin-right:20px;
        margin-bottom:10px;
        border-radius:2px;
    }

    .status:last-child{
        margin-right: 0px;
    }

    .status h6 {
        display:block;
        width:100%;
        font-size:1.6em;
        margin-top:5px;
        border-radius:5px;
        text-align:right;

    }

    .status i {
        font-size:3em;
    }

    .status-content{
        width:100%;
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        margin-right:20px;
        text-align:center;
        margin:auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/CardStatus.vue